<template>
  <div class="d-flex mt-1 mb-2 justify-content-center">
    <div class="input-wrapper" :class="{ error }">
      <VueDatePicker
        :placeholder="placeholder"
        v-model="newDate"
        :range="false"
        :multi-calendars="false"
        :multi-calendars-solo="false"
        :enable-time-picker="false"
        format="dd/MM/yyyy"
        hide-input-icon
        input-class-name="dp-hide-input-border"
        :flow="flow"
        :max-date="maxDate"
        :alt-position="altPosition"
        :start-date="startDate"
        teleport
        teleport-center
      />
      <div v-if="showErroIcon" class="error-icon-wrapper">
        <i class="fas fa-exclamation" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, ref, watch } from "vue";
import VueDatePicker from "@vuepic/vue-datepicker";

export default defineComponent({
  name: "DatePicker",
  components: { VueDatePicker },
  props: {
    value: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    maxLength: {
      type: Number,
      default: null,
    },
    fill: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    errorIcon: {
      type: Boolean,
      default: true,
    },
    maxDate: {
      type: Date,
      default: null,
    },
  },
  emits: ["update:value"],
  setup(props, { emit }) {
    const showErroIcon = computed(() => {
      if (props.error && props.errorIcon) {
        return true;
      }
      return false;
    });

    const flow = ref(["year", "month", "calendar"]);
    let initialDate = "";
    if (props.value) {
      const tempDate = new Date(props.value);
      initialDate = new Date(
        tempDate.getUTCFullYear(),
        tempDate.getUTCMonth(),
        tempDate.getUTCDate()
      ).toDateString();
    }
    const newDate = ref<string>(initialDate);

    const startDate = computed(() => props.maxDate ?? new Date());

    const altPosition = () => {
      const popupWidth = 300;
      const popupHeight = 300;
      const left = window.innerWidth / 2 - popupWidth / 2;
      const top = window.innerHeight / 2 - popupHeight / 2;
      return { top, left };
    };

    watch(newDate, (newValue) => {
      console.log("date", newValue);
      let formatDate = "";
      if (newValue && newValue != "") {
        formatDate = new Date(new Date(newValue).toDateString())
          .toISOString()
          .split("T")[0];
      }
      console.log("newdate", formatDate);
      emit("update:value", formatDate);
    });

    return {
      showErroIcon,
      flow,
      newDate,
      altPosition,
      startDate,
    };
  },
  methods: {
    //
  },
});
</script>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<style src="@vuepic/vue-datepicker/dist/main.css"></style>
<style lang="scss">
//Custom style for datepicker
.dp-hide-input-border {
  border: none !important;
  padding: 0px 6px !important;
}
</style>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";
$pj-color-red-opaque: rgba(222, 14, 14, 0.4);
.input-wrapper {
  height: 50px;
  background-color: white;
  border: 1px solid $pj-color-light-gray;
  border-radius: 11px;
  padding: 5px 20px;
  display: flex;
  flex-direction: row;
  align-items: center;

  &:focus-within {
    border: 1px solid $pj-color-black;
  }

  &.fill {
    width: 100%;
  }

  &.error {
    border: 1px solid $pj-color-red;
  }

  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }
}
.input-element {
  color: $pj-color-black;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  border: none;
  flex-grow: 1;
  height: 100%;
  width: 100%;

  &:focus-visible,
  &:focus,
  &:active {
    outline-width: 0;
  }

  &::placeholder {
    color: $pj-color-cool-gray;
  }
}
.error-icon-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  color: $pj-color-white;
  width: 36px;
  height: 36px;
  border-radius: 18px;
  background-color: $pj-color-red;
  border: 8px solid $pj-color-red-opaque;
  -webkit-background-clip: padding-box; /* for Safari */
  background-clip: padding-box; /* for IE9+, Firefox 4+, Opera, Chrome */
  font-size: 12px;

  i {
    margin: 0;
  }
}
</style>
